import { CONSTANTS } from '../../constants/constants';

const itemsExport = [
  { value: 'csv', label: 'CSV', textHelper: 'textHelperCSV' },
  { value: 'xlsx', label: 'XLSX', textHelper: 'textHelperXLSX' }
];

const itemsIdiomas = [
  { value: 'ES', label: 'ES' },
  { value: 'EN', label: 'EN' }
];

const itemsExportType = [
  { value: 'basic', label: 'basic' },
  { value: 'extended', label: 'extended' }
];

const lang = {
  es: 'ES',
  en: 'EN'
};

const statesForPending = [
  { value: CONSTANTS.DOCUMENT.STATUS.INIT, label: CONSTANTS.DOCUMENT.STATUS.INIT },
  { value: CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN, label: CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN },
  { value: CONSTANTS.DOCUMENT.STATUS.ERROR, label: CONSTANTS.DOCUMENT.STATUS.ERROR },
  { value: CONSTANTS.DOCUMENT.STATUS.REJECTED, label: CONSTANTS.DOCUMENT.STATUS.REJECTED }
];

const statesForFinished = [
  { value: CONSTANTS.DOCUMENT.STATUS.SIGNED, label: CONSTANTS.DOCUMENT.STATUS.SIGNED },
  { value: CONSTANTS.DOCUMENT.STATUS.CANCELLED, label: CONSTANTS.DOCUMENT.STATUS.CANCELLED }
];

const statesForBundles = [
  { value: CONSTANTS.DOCUMENT.STATUS.INIT, label: CONSTANTS.DOCUMENT.STATUS.INIT },
  { value: CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN, label: CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN },
  { value: CONSTANTS.DOCUMENT.STATUS.ERROR, label: CONSTANTS.DOCUMENT.STATUS.ERROR },
  { value: CONSTANTS.DOCUMENT.STATUS.REJECTED, label: CONSTANTS.DOCUMENT.STATUS.REJECTED },
  { value: CONSTANTS.DOCUMENT.STATUS.SIGNED, label: CONSTANTS.DOCUMENT.STATUS.SIGNED },
  { value: CONSTANTS.DOCUMENT.STATUS.CANCELLED, label: CONSTANTS.DOCUMENT.STATUS.CANCELLED },
  { value: CONSTANTS.BUNDLE.STATUS.READY, label: CONSTANTS.BUNDLE.STATUS.READY }
];

const handleStateByPath = (pathname) => {
  switch (pathname) {
    case '/document':
      return statesForPending;
    case '/document/finished':
      return statesForFinished;
    case '/bundle':
      return statesForBundles;
    default:
      return statesForBundles.filter((item) => item.value !== CONSTANTS.BUNDLE.STATUS.READY);
  }
};

const valitionForm = (formState, t) => {
  const { exportAs, exportType, dateRange } = formState;
  if (exportAs && typeof exportType === 'boolean') {
    return validateDate(dateRange.startDate, dateRange.endDate, t);
  } else {
    const errors = [];
    if (!exportAs) errors.push(t('exportData:exportLike'));
    if (!exportType) errors.push(('exportData:type'));
    return `${t('exportData:errorMissingParameter')}: ${errors.join(', ')}`;
  }
};

const validateDate = (date1, date2, t) => {
  const selectedDate1 = new Date(date1);
  const selectedDate2 = new Date(date2);
  const lastTwelveMonths = new Date();
  lastTwelveMonths.setFullYear(lastTwelveMonths.getFullYear() - 1);

  if (selectedDate1 > selectedDate2) {
    console.log('error');
    return t('exportData:errorDate');
  } else if (selectedDate1 < lastTwelveMonths) {
    return t('exportData:errorDateRange');
  }
};

export { itemsExport, itemsIdiomas, itemsExportType, lang, valitionForm, validateDate, handleStateByPath };
